<template lang="html">
  <span ref="letter" @mouseenter="enter" @mousemove="move" @mouseleave="leave">{{ letter }}</span>
</template>

<script>
export default {
  props: {
    letter: String
  },
  data () {
    return {
      enterY: 0,
      moveY: 0,
    }
  },
  mounted() {
    let target = this.$refs.letter
    let random = Math.floor(Math.random() * Math.floor(20));
    target.style.transform = "translateY(" + random + "px)"
  },
  methods: {
    enter (event) {
      let target = event.target
      this.enterY = target.style.transform.replace(/[^\d.]/g, '')
      this.moveY = event.clientY
    },
    move (event) {
      let target = event.target
      // console.log()
      let diff = (event.clientY - this.moveY)
      if(Math.abs(diff) < 30) {
        target.style.transform = "translateY(" + diff + "px)"
      }
    },
    leave (event) {
      let target = event.target
      let diff = (event.clientY - this.moveY)
      if(Math.abs(diff) < 30) {
        target.style.transform = "translateY(" + diff + "px)"
      }
    },
  }
}
</script>

<style lang="scss" scoped>
span {
  position: relative;
  display:inline-block;
  transition: transform .1s;
}
</style>
